import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/star-scandal', label: '明星黑料' },
  { path: '/category/romance-exposure', label: '恋情曝光' },
  { path: '/category/variety-insider', label: '综艺内幕' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const bgClass = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50';

  const textClass = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-900';

  const borderClass = scrolled ? 'border-b border-background-200/70' : 'border-b border-transparent';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass} ${borderClass}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`flex items-center gap-2 ${textClass}`}>
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-line text-2xl"></i>
            </div>
            <span className="font-heading text-xl font-bold whitespace-nowrap">黑料不打烊</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.path
                    ? isHome && !scrolled ? 'text-white border-b-2 border-white' : 'text-primary-500'
                    : textClass
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`text-sm whitespace-nowrap px-4 py-2 rounded-md transition-all duration-200 ${
              isHome && !scrolled
                ? 'border border-white/40 text-white hover:bg-white/10'
                : 'border border-background-300 text-foreground-700 hover:bg-background-100'
            }`}>
              <i className="ri-search-line mr-1"></i>
              搜索
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center ${textClass}`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-md transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}